<template>
    <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-container class="pa-0">
                    <v-row justify="space-between" dense align="center">
                        <v-col cols="auto">
                            <v-toolbar-title>
                                {{ widget.body.title }}
                            </v-toolbar-title>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col class="pa-0" cols="12">
                            <v-btn
                                text
                                icon
                                color="blue-grey"
                                data-sentry-label="Poprzedni dzień"
                                :disabled="disableBackward || loading"
                                @click="previousDay()"
                            >
                                <v-icon>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <span class="text-subtitle-2">
                                {{ currentDateFormatted }}
                            </span>
                            <v-btn
                                text
                                icon
                                color="blue-grey"
                                data-sentry-label="Następny dzień"
                                :disabled="disableForward || loading"
                                @click="nextDay()"
                            >
                                <v-icon>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
                <v-progress-linear v-if="loading" indeterminate color="primary" class="my-2" />
                <v-data-table
                    v-else
                    :headers="headers"
                    :items="content"
                    :mobile-breakpoint="0"
                    dense
                    hide-default-footer
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.shipper }}
                            </td>
                            <td>
                                {{ item.amount }}
                            </td>
                        </tr>
                    </template>
                    <template v-if="content.length > 0" #body.append>
                        <tr>
                            <td />
                            <td class="font-weight-bold">
                                {{ totalAmount }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { format, subDays, addDays, isToday } from 'date-fns'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'OrdersSentDailyByShipperReport',
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Nazwa',
                    value: 'shipper',
                    sortable: false,
                },
                {
                    text: 'Ilość',
                    value: 'amount',
                    sortable: false,
                },
            ],
            currentDate: new Date(),
            content: [],
            loading: false,
            maxDaysBack: 30,
            dayOffset: 0,
        }
    },
    computed: {
        currentDateFormatted() {
            return format(this.currentDate, 'DD.MM.YYYY')
        },
        currentDateQuery() {
            return format(this.currentDate, 'YYYY-MM-DD')
        },
        disableForward() {
            return isToday(this.currentDate)
        },
        disableBackward() {
            return this.dayOffset >= this.maxDaysBack
        },
        totalAmount() {
            return this.content.reduce((sum, item) => sum + item.amount, 0)
        },
    },
    created() {
        this.content = this.widget.body.content || []
    },
    methods: {
        previousDay() {
            this.dayOffset++
            this.currentDate = subDays(this.currentDate, 1)
            this.fetchData()
        },
        nextDay() {
            this.dayOffset--
            this.currentDate = addDays(this.currentDate, 1)
            this.fetchData()
        },
        fetchData() {
            this.loading = true
            this.$store.dispatch('dashboard/getDashboardItem', {
                item: this.widget,
                paginate: '',
                query: `?sent_date=${this.currentDateQuery}`
            })
                .then(response => {
                    this.content = response.data.body.content || []
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    }
}
</script>